import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { applicationDocumentsApi, type ApplicationDocumentType } from '@/features/recruiter/api/applicationDocuments.api'

const key = (applicationId: number) => ['recruiter', 'application-documents', applicationId]

export function useApplicationDocumentsQuery(applicationId: number) {
  return useQuery({
    queryKey: key(applicationId),
    queryFn: () => applicationDocumentsApi.list(applicationId),
    enabled: applicationId > 0,
  })
}

export function useUploadApplicationDocument(applicationId: number) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ documentType, file }: { documentType: ApplicationDocumentType; file: File }) =>
      applicationDocumentsApi.upload(applicationId, documentType, file),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: key(applicationId) }),
  })
}

export function useDeleteApplicationDocument(applicationId: number) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (documentId: number) => applicationDocumentsApi.delete(applicationId, documentId),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: key(applicationId) }),
  })
}

export function useDownloadApplicationDocument(applicationId: number) {
  return useMutation({
    mutationFn: (documentId: number) => applicationDocumentsApi.download(applicationId, documentId),
    onSuccess: (url) => window.open(url, '_blank'),
  })
}
